import { render, staticRenderFns } from "./partner-profile-details.vue?vue&type=template&id=5aedb0bd&scoped=true&"
import script from "./partner-profile-details.ts?vue&type=script&lang=ts&"
export * from "./partner-profile-details.ts?vue&type=script&lang=ts&"
import style0 from "./partner-profile-details.scss?vue&type=style&index=0&id=5aedb0bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aedb0bd",
  null
  
)

export default component.exports